export const preserveScrollPosition = (
  container: HTMLElement,
  spacer: HTMLElement,
  scrollTop: number,
): void => {
  // scrollHeight is floored at clientHeight, so use the final spacer's position
  // to measure content that may now be shorter than the viewport.
  const contentHeight = spacer.getBoundingClientRect().top - container.getBoundingClientRect().top
    + container.scrollTop - container.clientTop
    + (Number.parseFloat(getComputedStyle(container).paddingBottom) || 0);
  // Keep only the extent needed by the current viewport when results shrink.
  // Growing content or scrolling upward naturally releases the extra space.
  spacer.style.height = `${scrollTop > 0 ? Math.max(0, scrollTop + container.clientHeight - contentHeight) : 0}px`;
  container.scrollTop = scrollTop;
};
